// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3RfBr","right":"Footer_right__2uISG","buttons":"Footer_buttons__1sDdD"};